import HTTP from '../common/http-common';

const END_POINT = '/branch';

const listBranch = () => HTTP.get(END_POINT, { cache: false });
const isExistBranchCode = (branchCode, branchId) => HTTP.get(END_POINT +  "/branchcode/" + branchCode + "/" + branchId, { cache: false });
const insert = (data) => HTTP.post(END_POINT, {
    branchCode: data.branchCode,
    branchName: data.branchName,
    companyCode: data.companyCode,
    address: data.address,
    taxId: data.taxId,
    morningStartTime: data.morningStartTime,
    morningEndTime: data.morningEndTime,
    noonStartTime: data.noonStartTime,
    noonEndTime: data.noonEndTime,
    percentInsuranceMall: data.percentInsuranceMall,
    percentInsuranceGarage: data.percentInsuranceGarage,
    percentInhouse: data.percentInhouse,
    percentCash: data.percentCash,
    percentCredit: data.percentCredit
});
const update = (data) => HTTP.post(END_POINT + "/" + data.branchId, {
    branchCode: data.branchCode,
    branchName: data.branchName,
    companyCode: data.companyCode,
    address: data.address,
    taxId: data.taxId,
    morningStartTime: data.morningStartTime,
    morningEndTime: data.morningEndTime,
    noonStartTime: data.noonStartTime,
    noonEndTime: data.noonEndTime,
    percentInsuranceMall: data.percentInsuranceMall,
    percentInsuranceGarage: data.percentInsuranceGarage,
    percentInhouse: data.percentInhouse,
    percentCash: data.percentCash,
    percentCredit: data.percentCredit
});

const deleteBranch = (branchId) => HTTP.delete(END_POINT + "/" + branchId);

export {
    listBranch,
    isExistBranchCode,
    insert,
    update,
    deleteBranch
}